module.exports = __webpack_public_path__ + "onboarding-sidebar-bad.e9c66d9084a395dff01464e8c896dfb3.hashedasset.png";